var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card"},[_c('p',{staticClass:"image is-64x64"},[_c('b-skeleton',{attrs:{"circle":"","width":"64px","height":"64px"}})],1),_c('p',[_c('b-skeleton',{attrs:{"width":"180px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }